import ShowLocation from './ShowLocation'

export default ShowLocation
